import React from 'react';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import Selectors from 'src/utils/selectors';
import LiteralsService from 'src/services/literals/LiteralsService';
import FormatService from 'src/services/format.service';
import Typography from 'src/components/typography/Typography';
import colors from 'src/styles/colors.module.scss';
import styles from './budgetAmount.module.scss';

interface BudgetAmountProps {
    amount: number;
}
export default function BudgetAmount({ amount }: BudgetAmountProps): JSX.Element {
    const formattedAmount: string = FormatService.formatCurrency(amount);
    return (
        <Typography
            id="budget-amount"
            variant={TypographyVariants.LEGAL_PRIMARY}
            className={colors.textWeak}
            data-cy={Selectors.SpendSmart.BUDGET_AMOUNT}
        >
            {LiteralsService.getLiteral('BudgetAmount.title')}
            <Typography variant={TypographyVariants.LEGAL_SECONDARY} className={styles.formattedAmount}>
                {formattedAmount}
            </Typography>
        </Typography>
    );
}
